__turbopack_context__.v({
  "simple-entries": "HA58xq_simple-entries",
  "simple-entries__content": "HA58xq_simple-entries__content",
  "simple-entries__content--open": "HA58xq_simple-entries__content--open",
  "simple-entries__entry-content": "HA58xq_simple-entries__entry-content",
  "simple-entries__entry-content--active": "HA58xq_simple-entries__entry-content--active",
  "simple-entries__icon": "HA58xq_simple-entries__icon",
  "simple-entries__icon--active": "HA58xq_simple-entries__icon--active",
  "simple-entries__item": "HA58xq_simple-entries__item",
  "simple-entries__toggle": "HA58xq_simple-entries__toggle",
});
